import { languages } from 'core/intl/languages';
import { UserProfileSetting, UserSettingsDTO } from 'models/user';

export const extractSettingsLanguage = (settings: UserSettingsDTO[]) => {
  return settings.find((s) => s.code === UserProfileSetting.Language)?.value;
};

export const getLanguageCode = (lang: string) =>
  languages.find((l) => l.name === lang)?.code;
